import { useAccount, useBalance, useReadContracts } from "wagmi";
import { useIdle } from "react-use";

import { toFixedWithoutRounding } from "../constants/common";

import useDappConfig from "./useDappConfig";
// import useDappChain from "./useDappChain";
import { formatUnits } from "viem";
import { contractConfig } from "@config/contractsConfig";

const useTokenBalanceForChain = (chainId: number) => {
  const isIdle = useIdle(150e3);
  const { address: walletAddress } = useAccount();
  const { vaultsContractConfig } = useDappConfig();
  const config = contractConfig[chainId];
  const tokens = config?.tokens || {};
  const tokenKeys = Object.keys(tokens);

  const balancesForTokens = [
    ...tokenKeys.map((token) => tokens[token]),
    ...(config?.xtoken ? [config?.xtoken] : []),
    { ...(vaultsContractConfig[chainId]?.xToken || {}) },
  ];

  const filteredBalancesForTokens = balancesForTokens?.filter(
    (token) => Object.keys(token).length > 0
  );

  const { data: tokensBalances } = useReadContracts({
    contracts: filteredBalancesForTokens.map((token) => ({
      address: token.address,
      abi: token.abi,
      functionName: "balanceOf",
      args: [walletAddress],
      chainId: chainId,
    })),
    query: {
      enabled: !isIdle && !!walletAddress,
      refetchInterval: 5_000,
    },
  });

  const { data: nativeTokenBalance } = useBalance({
    address: walletAddress,
    query: {
      enabled: !isIdle && !!walletAddress,
      refetchInterval: 5_000,
      initialData: {
        decimals: config?.nativeToken?.decimals,
        formatted: "0",
        symbol: config?.nativeToken?.symbol,
        value: 0n,
      },
    },
  });

  const supportedTokenBalances: { [x: string]: number } = tokensBalances
    ? tokensBalances
      .map((res) => res.result! as bigint)
      .reduce((acc, curr, index) => {
        return {
          ...acc,
          [filteredBalancesForTokens[index].symbol]: +toFixedWithoutRounding(
            curr
              ? formatUnits(curr, filteredBalancesForTokens[index].decimals)
              : "0",
            8
          ),
        };
      }, {})
    : {};

  return {
    tokensBalances: tokensBalances ? supportedTokenBalances : {},
    nativeTokenBalance: +toFixedWithoutRounding(
      nativeTokenBalance?.formatted || "0",
      8
    ),
    xTokenTokenBalance: supportedTokenBalances[config?.xtoken?.symbol],
    xTokenVaultBalance:
      supportedTokenBalances[vaultsContractConfig[chainId]?.xToken?.symbol],
  };
};

export default useTokenBalanceForChain;
